export const now = (): Date => new Date();
